module.exports = __webpack_public_path__ + "media/images/konintodoke/twitter-icon-133d88c526dd251cd037b18720da0284.svg";